import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { ProposalEstimate } from 'src/app/models/proposal-estimate';
import cloneDeep from 'lodash/cloneDeep';
import { Constants } from 'src/app/core/constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { FormService } from 'src/app/services/form';
import { EstimateDetailsComponent } from '../../common/estimate-details/estimate-details.component';
import { AppSettings } from 'src/app/app.settings';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import Helper from 'src/app/core/utility/helper';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-pe-view-estimate',
  templateUrl: './pe-view-estimate.component.html',
  styleUrls: ['./pe-view-estimate.component.scss']
})
export class PeViewEstimteComponent extends BasePage implements OnInit {
  pageName: string = 'viewestimate';
  childControlTooltipText: string = '';
  appSettings: AppSettings;
  IsEmployee: boolean;
  IsEmployee$: Observable<boolean>;
  EstimateId: Number;
  EstimateRequestId: string;
  EstimateDTOList: ProposalEstimate[];
  public formErrors = {

  };
  public EstimateCommentFormErrors = {
      EstimateComment: '',
  };
  viewEstimateForm: FormGroup;
  EstimateCommentForm: FormGroup;
  @ViewChild(EstimateDetailsComponent)
  EstimateDetailsComponent: EstimateDetailsComponent;
  formSubmitted = false;

  constructor(
      private dataService: DataService,
      private router: Router,
      private toastService: ToastService,
      localstorageService: LocalstorageService,
      public FormService: FormService,
      private appGlobalDataService: AppGlobalDataService,
      private fb: FormBuilder,
      logger: NGXLogger,
      appSettings: AppSettings,
          private readonly route: ActivatedRoute
  ) {
      super(localstorageService, logger, appSettings);
      this.viewEstimateForm = this.fb.group({
      });
      this.EstimateCommentForm = this.fb.group({
          EstimateComment: [null],
      });
      this.appSettings = appSettings;
  }

  ngOnInit() {
      // this.EstimateService.EstimateToReviewId.subscribe(id => {
      //   this.getEstimate(id);
      // })
      this.route.paramMap.subscribe(params => {
          this.EstimateRequestId = params.get('id');
          if (this.EstimateRequestId) {
              this.getEstimate(this.EstimateRequestId);
          }
      });
      this.setFlags();
  }

  getEstimate(id: string) {
      this.dataService.getEstimate(id).subscribe((response: any) => {
          if (response && response.Data != null) {
            this.EstimateDTOList = response.Data;
            this.EstimateId = this.EstimateDTOList[0].EstimateId;
            const ids: number[] = [];

          }

      });
  }

  

  RejectEstimates() {

      this.ValidateForm();
      if (this.viewEstimateForm.valid) {
      }
  }
  ApproveEstimates() {
  }

  updateEstimateStatus() {
  }

  ValidateForm() {
      this.formErrors = this.FormService.validateForm(
          <FormGroup>this.viewEstimateForm,
          this.formErrors
      );
  }

  ValidateEstimateCommentForm() {
      this.EstimateCommentFormErrors = this.FormService.validateForm(
          <FormGroup>this.EstimateCommentForm,
          this.EstimateCommentFormErrors
      );
  }
  closeWindow() {
      window.opener.location.reload(true);
      window.close();
  }
  refreshToolTipText(code: string) {
      this.childControlTooltipText = Constants[code];
  }


}
